export default __webpack_public_path__ + "static/media/post6.cde17268.png";